import { lazyLoad } from 'utils/loadable';

export const PlacementDocViewerLoadableWeb = lazyLoad(
  () => import('./PlacementDocViewerWeb'),
  module => module.PlacementDocViewerWeb,
);
